module.exports = "/_next/static/files/b7d26c7b401bcdd26f96afef1c7b22f6.svg";